import { App } from '@capacitor/app';
import { IonSpinner, IonText } from '@ionic/react';
import useData from 'hooks/useData';
import { Suspense } from 'react';

const VersionFooter = () => {
  // For web app, use environment variables from build.gradle, for mobile use App.getInfo
  const isWeb = process.env.REACT_APP_IS_WEB === 'true';
  
  // Get version info from environment variables (extracted at build time)
  const webVersionName = process.env.REACT_APP_VERSION_NAME || '1.1.6';
  const webVersionCode = process.env.REACT_APP_VERSION_CODE || '183';
  
  // Always call hooks in the same order - use environment variables for web
  const [data, loading, error] = useData(isWeb ? 
    () => Promise.resolve({version: webVersionName, build: webVersionCode}) 
    : App.getInfo);
  
  if (isWeb) {
    // For web app, show version from environment variables (build.gradle)
    return (
      <IonText color="--ion-text-color">
        version {webVersionName} - build {webVersionCode} - SPINNAX GmbH
      </IonText>
    );
  }

  if (error) {
    return (
      <div className="errors error-message">
        <p>Version - {error.toString()}</p>
      </div>
    );
  }
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <IonSpinner name="crescent" style={{ width: 48, height: 48 }} />
      </div>
    );
  }

  return (
    <div>
      <Suspense
        fallback={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <IonSpinner name="crescent" style={{ width: 48, height: 48 }} />
          </div>
        }
      >
        <IonText color="--ion-text-color">
          version {data?.version} - build {data?.build}
        </IonText>
      </Suspense>
    </div>
  );
};
export default VersionFooter;
